class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
        this.expiresDate = this.popup.getAttribute('data-expire');
        this.suppressDays = Math.max(parseInt(this.expiresDate, 10) || 0, 30);
        this.storageKey = 'newsletter-popup-closed-until';
        this.reopenButton = document.querySelector('[data-newsletter-reopen]');
        this.dismissReopenButton = document.querySelector('[data-dismiss-newsletter-reopen]');

        if (!this.isPopupSuppressed()) {
            setTimeout(() => {
                document.body.classList.remove('newsletter-reopen-visible');
                document.body.classList.add('newsletter-show');
            }, this.timeToShow);

            setTimeout(() => {
                document.body.classList.add('show-newsletter-image');
            }, this.timeToShow + 700);
        } else {
            this.showReopenButton();
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        this.querySelectorAll('[data-close-newsletter-popup]').forEach((button) => {
            button.addEventListener('click', this.setClosePopup.bind(this));
        });

        this.querySelector('#ContactPopup').addEventListener(
            'submit',
            this.setClosePopup.bind(this)
        );

        const copyCouponButton = this.querySelector('[data-copy-newsletter-coupon]');
        if (copyCouponButton) {
            copyCouponButton.addEventListener('click', this.copyCoupon.bind(this));
        }

        if (this.reopenButton) {
            this.reopenButton.addEventListener('click', this.openPopup.bind(this));
        }

        if (this.dismissReopenButton) {
            this.dismissReopenButton.addEventListener('click', this.dismissReopenButtonForSession.bind(this));
        }
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        const secure = window.location.protocol === 'https:' ? ';Secure' : '';
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;SameSite=Lax' + secure;
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    isPopupSuppressed() {
        if (this.getCookie('newsletter-popup') !== '') return true;

        try {
            const closedUntil = Number(localStorage.getItem(this.storageKey));
            return Number.isFinite(closedUntil) && closedUntil > Date.now();
        } catch (error) {
            return false;
        }
    }

    persistPopupClose() {
        this.setCookie('newsletter-popup', 'closed', this.suppressDays);

        try {
            const closedUntil = Date.now() + (this.suppressDays * 24 * 60 * 60 * 1000);
            localStorage.setItem(this.storageKey, String(closedUntil));
        } catch (error) {
            // The first-party cookie above remains as the fallback.
        }
    }

    copyCoupon(event) {
        const button = event.currentTarget;
        const code = button.getAttribute('data-code');
        const copiedLabel = button.getAttribute('data-copied-label') || 'Copied!';

        if (!code || !navigator.clipboard) return;

        navigator.clipboard.writeText(code).then(() => {
            button.textContent = copiedLabel;
            button.setAttribute('aria-label', copiedLabel);
        });
    }

    openPopup(event) {
        event.preventDefault();
        document.body.classList.remove('newsletter-reopen-visible');
        document.body.classList.add('newsletter-show', 'show-newsletter-image');
    }

    showReopenButton() {
        if (sessionStorage.getItem('newsletter-reopen-dismissed') !== 'true' && sessionStorage.getItem('newsletter-subscribed') !== 'true') {
            document.body.classList.add('newsletter-reopen-visible');
        }
    }

    dismissReopenButtonForSession(event) {
        event.preventDefault();
        event.stopPropagation();
        sessionStorage.setItem('newsletter-reopen-dismissed', 'true');
        document.body.classList.remove('newsletter-reopen-visible');
    }

    setClosePopup(event) {
        this.persistPopupClose();
        document.body.classList.remove('newsletter-show');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700);

        if (!event || event.type !== 'submit') {
            this.showReopenButton();
        }
    }

    onBodyClickEvent(event) {
        if ((!this.contains(event.target)) && (event.target.closest?.('[data-open-newsletter-popup]') == null) && document.body.classList.contains('newsletter-show')) {
            this.setClosePopup();
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    close() {
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event) {
        if (!this.contains(event.target)) {
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);